import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'shared-core-observable-toast',
  imports: [],
  templateUrl: './observable-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObservableToastComponent {
  readonly message = input.required<string>();
}
